// extracted by mini-css-extract-plugin
export default {"btnText":"ButtonText_btnText__nUwuS"};